<div class="line-chart">
  <div class="line-chart__y-axis">
    @for (tick of chartYTicks(); track tick) {
      <span class="line-chart__y-label" [style.top.%]="gridYPct(tick)">{{ tick | number:'1.0-1' }}</span>
    }
  </div>
  <div class="line-chart__plot" (mouseleave)="onChartLeave()">
    <svg class="line-chart__svg" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      @for (tick of chartYTicks(); track tick) {
        <line class="line-chart__gridline" x1="0" [attr.y1]="gridYPct(tick)" x2="100" [attr.y2]="gridYPct(tick)" />
      }
      <polyline class="line-chart__line" [attr.points]="chartLinePoints()" />
    </svg>
    @for (p of points; track p.label; let i = $index) {
      <button
        type="button"
        class="line-chart__point"
        [class.line-chart__point--hovered]="hoveredIndex === i"
        [style.left.%]="chartPointXPct(i)"
        [style.top.%]="chartPointYPct(p.value)"
        (mouseenter)="onPointHover(i)"
        [attr.aria-label]="(dateLabels ? (p.label | date:'MMM d') : p.label) + ': ' + p.value + ' ' + valueLabel"
      ></button>
    }
    @if (hoveredPoint; as point) {
      <div class="line-chart__tooltip" [style.left.%]="chartPointXPct(hoveredIndex!)">
        <strong>{{ dateLabels ? (point.label | date:'MMM d, y') : point.label }}</strong>
        {{ point.value | number }} {{ valueLabel }}
      </div>
    }
  </div>
  <div class="chart-date-labels">
    @for (p of thinnedPoints(); track p.label) {
      <span class="chart-date-label">{{ dateLabels ? (p.label | date:'MMM d') : p.label }}</span>
    }
  </div>
</div>
